// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"53":"webfontloader","207":"timeregistration","594":"about"}[chunkId] || chunkId) + "." + {"53":"9380816b","125":"76a852cb","179":"58a938e3","207":"b2a1c7e1","330":"1f391d69","594":"0ac2fbf3"}[chunkId] + ".js";
};